const autocompleteModalAction = {
  user: 'Responsables',
  helperText: 'Cantidad máxima de responsables:',
};

export default autocompleteModalAction;
